/* MINAMI cart drawer: countdown, in-cart size/colour switching, upsell adds,
   and the bag icon on product cards.
 *
 * This deliberately does NOT swap the drawer's HTML itself. Every cart write asks
 * Shopify for the cart-drawer section in the same request and hands the result to
 * the theme's own <cart-drawer>.renderContents(), which is what re-binds the close
 * buttons, the note and shipping dialogs, the item count badge and the theme's
 * shipping bar. Doing it any other way silently kills those.
 *
 * Variant clicks repaint from local data first so the row changes instantly, then
 * the cart call runs in the background.
 */
(function () {
  if (window.__cdInit) return;
  window.__cdInit = true;

  var KEY = 'cd_reserve_deadline';
  var busy = false;
  var timer = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function drawerEl() { return document.querySelector('cart-drawer'); }
  function drawerIsOpen() {
    var d = drawerEl();
    return !!d && d.classList.contains('open');
  }

  function openDrawer() {
    var btn = document.querySelector('[data-cart-drawer-btn]');
    if (btn) { btn.click(); return; }
    var d = drawerEl();
    if (d) {
      d.classList.add('open');
      document.body.classList.add('no-scroll');
    }
  }

  /* Hand a cart-write response straight to the theme's renderer. */
  function render(res) {
    var d = drawerEl();
    if (!d || !res || !res.sections || !res.sections['cart-drawer']) return false;
    try {
      d.renderContents(res);
      paintTimer();
      if (window.__amrbRefresh) window.__amrbRefresh();
      return true;
    } catch (e) {
      return false;
    }
  }

  /* No cart write to piggyback on — fetch the section and fake the same shape. */
  function refreshDrawer() {
    return fetch(root() + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        render({ sections: { 'cart-drawer': html } });
      })
      .catch(function () {});
  }

  function scheduleRefresh(andOpen) {
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var wasClosed = !drawerIsOpen();
      refreshDrawer().then(function () {
        if (andOpen && wasClosed) openDrawer();
      });
    }, 140);
  }

  function post(url, body) {
    body.sections = ['cart-drawer'];
    body.sections_url = window.location.pathname;
    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* ---------- money ----------
     Regexes are built with RegExp() rather than literals on purpose: this file
     is written through an API that treats a lone backslash as literal, so a
     /regex/ literal would arrive mangled. */
  var RE_THOUSANDS = new RegExp("\\B(?=(\\d{3})+(?!\\d))", "g");
  var RE_TOKEN = new RegExp("\\{\\{\\s*(\\w+)\\s*\\}\\}", "g");

  function money(cents, format) {
    var value = cents / 100;
    function num(dec, thou, mark) {
      var parts = value.toFixed(dec).split('.');
      parts[0] = parts[0].replace(RE_THOUSANDS, thou);
      return dec ? parts.join(mark) : parts[0];
    }
    return (format || '£{{amount}}').replace(RE_TOKEN, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(0, ' ', ',');
        case 'amount_with_period_and_space_separator': return num(2, ' ', '.');
        default: return num(2, ',', '.');
      }
    });
  }

  /* ---------- countdown ---------- */
  function two(n) { return (n < 10 ? '0' : '') + n; }

  function paintTimer() {
    var el = document.querySelector('[data-cd-timer]');
    if (!el) return;
    var mins = parseInt(el.getAttribute('data-minutes') || '10', 10);
    var deadline = 0;
    try { deadline = parseInt(sessionStorage.getItem(KEY) || '0', 10); } catch (e) {}
    var now = Date.now();
    if (!deadline || deadline < now) {
      deadline = now + mins * 60000;
      try { sessionStorage.setItem(KEY, String(deadline)); } catch (e) {}
    }
    var left = Math.max(0, Math.round((deadline - now) / 1000));
    el.textContent = two(Math.floor(left / 60)) + ':' + two(left % 60);
  }
  setInterval(paintTimer, 1000);

  /* ---------- the bag icon on a product card ----------
     The theme wires that icon to its quick-view drawer. This intercepts it in
     the capture phase — before the theme's own <quick-view> element sees the
     click — adds the first AVAILABLE variant and opens the cart drawer instead.

     Out of stock, or the product JSON won't load, and it falls through: the
     shopper lands on the product page rather than on nothing. Because the cart
     drawer carries size pills on every line, they can change size there without
     leaving. */
  function spin(a, on) {
    var loader = a.querySelector('[data-spin-loader]');
    var icon = a.querySelector('.quick-view-icon');
    if (loader) loader.classList.toggle('hidden', !on);
    if (icon) icon.style.visibility = on ? 'hidden' : '';
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-quickview]');
    if (!a) return;

    var host = a.closest('quick-view');
    var url = (host && host.getAttribute('data-product-url')) || a.getAttribute('href');
    if (!url) return;

    e.preventDefault();
    e.stopPropagation();
    if (busy) return;

    busy = true;
    spin(a, true);

    fetch(url.split('?')[0] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        if (!v) throw new Error('nothing available');
        return post('cart/add.js', { items: [{ id: v.id, quantity: 1 }] });
      })
      .then(function (res) {
        spin(a, false);
        busy = false;
        if (!render(res)) return refreshDrawer().then(openDrawer);
        if (!drawerIsOpen()) openDrawer();
      })
      .catch(function () {
        spin(a, false);
        busy = false;
        window.location.href = url;
      });
  }, true);

  /* ---------- variant pickers ---------- */
  function parse(el, attr) {
    try { return JSON.parse(el.getAttribute(attr) || 'null'); } catch (e) { return null; }
  }

  function swatchIndex(pk) {
    var sw = pk.querySelector('.cd__sw[data-i]');
    return sw ? parseInt(sw.getAttribute('data-i'), 10) : -1;
  }

  function matches(v, sel, ignore) {
    for (var k = 0; k < sel.length; k++) {
      if (k === ignore) continue;
      if (v.o[k] !== sel[k]) return false;
    }
    return true;
  }

  function paintPicker(pk) {
    var vs = parse(pk, 'data-variants') || [];
    var sel = parse(pk, 'data-sel') || [];
    var swIdx = swatchIndex(pk);

    Array.prototype.forEach.call(pk.querySelectorAll('[data-cd-opt]'), function (b) {
      var i = parseInt(b.getAttribute('data-i'), 10);
      var v = b.getAttribute('data-v');
      var on = sel[i] === v;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');

      var avail = vs.some(function (x) {
        if (!x.a || x.o[i] !== v) return false;
        if (i === swIdx) return true;
        return matches(x, sel, i);
      });
      b.disabled = !avail;
      b.classList.toggle('is-off', !avail);
    });

    var card = pk.closest('[data-cd-up]');
    var add = card && card.querySelector('[data-cd-add]');
    if (add) {
      var hit = vs.filter(function (x) { return x.a && matches(x, sel, -1); })[0];
      if (hit) {
        add.setAttribute('data-cd-add', hit.id);
        add.disabled = false;
      } else {
        add.disabled = true;
      }
    }
  }

  function paintLine(pk, hit) {
    var li = pk.closest('.cd__item');
    if (!li) return;
    var qty = parseInt(pk.getAttribute('data-qty') || '1', 10);

    var price = li.querySelector('.cd__item-price');
    if (price && typeof hit.p === 'number') {
      var was = price.querySelector('s');
      price.textContent = money(hit.p * qty, pk.getAttribute('data-money'));
      if (was) price.appendChild(was);
    }

    if (hit.img) {
      var img = li.querySelector('.cd__item-media img');
      if (img) {
        img.removeAttribute('srcset');
        img.src = hit.img;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cd-opt]');
    if (!b || b.disabled) return;
    e.preventDefault();

    var pk = b.closest('[data-cd-picker]');
    if (!pk) return;
    var vs = parse(pk, 'data-variants') || [];
    var sel = parse(pk, 'data-sel') || [];
    var i = parseInt(b.getAttribute('data-i'), 10);
    var val = b.getAttribute('data-v');
    if (sel[i] === val) return;

    sel[i] = val;
    var hit = vs.filter(function (x) { return x.a && matches(x, sel, -1); })[0];
    if (!hit) hit = vs.filter(function (x) { return x.a && x.o[i] === val; })[0];
    if (!hit) return;

    pk.setAttribute('data-sel', JSON.stringify(hit.o));
    paintPicker(pk);

    if (pk.getAttribute('data-mode') === 'upsell') return;

    paintLine(pk, hit);

    var oldKey = pk.getAttribute('data-key');
    if (!oldKey || busy) return;
    pk.setAttribute('data-key', '');
    busy = true;
    window.__cdSwapping = true;
    var qty = parseInt(pk.getAttribute('data-qty') || '1', 10);

    /* Add the new one BEFORE removing the old one. The other way round empties
       the cart for a moment and the drawer flashes its empty state. */
    post('cart/add.js', { items: [{ id: Number(hit.id), quantity: qty }] })
      .then(function () {
        var updates = {};
        updates[oldKey] = 0;
        return post('cart/update.js', { updates: updates });
      })
      .then(function (res) {
        busy = false;
        window.__cdSwapping = false;
        if (!render(res)) return refreshDrawer();
      })
      .catch(function () {
        busy = false;
        window.__cdSwapping = false;
        return refreshDrawer();
      });
  });

  /* ---------- upsell add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cd-add]');
    if (!btn || btn.disabled || busy) return;
    e.preventDefault();

    var id = btn.getAttribute('data-cd-add');
    if (!id) return;

    busy = true;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = btn.getAttribute('data-adding') || 'Adding';

    post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function (res) {
        btn.textContent = btn.getAttribute('data-added') || 'Added';
        btn.classList.add('is-added');
        busy = false;
        if (!render(res)) return refreshDrawer();
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
        busy = false;
      });
  });

  /* ---------- watch every cart write, however it is sent ----------
     The theme adds to cart from product pages and product cards. Whether it
     uses fetch or XHR, the drawer needs to know. Our own writes are skipped
     because they render the response themselves. Plain string checks, no
     regex, for the same escaping reason as above. */
  var CART_WRITES = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function isCartWrite(url) {
    if (typeof url !== 'string') return false;
    for (var i = 0; i < CART_WRITES.length; i++) {
      if (url.indexOf(CART_WRITES[i]) !== -1) return true;
    }
    return false;
  }

  function onCartWrite(url) {
    if (!isCartWrite(url)) return;
    if (busy) return;
    scheduleRefresh(url.indexOf('/cart/add') !== -1);
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (url && typeof url === 'object' && url.url) url = url.url;
    var req = origFetch.apply(this, arguments);
    if (typeof url === 'string') {
      req.then(function () { onCartWrite(url); }).catch(function () {});
    }
    return req;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cdUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    xhr.addEventListener('load', function () { onCartWrite(xhr.__cdUrl); });
    return origSend.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintTimer);
  } else {
    paintTimer();
  }
})();